import { gql } from '@apollo/client'

export const PROVIDERS_SUBMIT_LIST_QUERY = gql`
  query ProvidersSubmitList($propertyCode: String!) {
    providersSubmitList(propertyCode: $propertyCode) {
      providerCode
      displayProviderCode
      providerName
      providerNameTranslatedList {
        label
        nativeLabel
        value
      }
      providerConnections {
        status
        availability {
          providerAdapter
          providerURL
          manualARR
          pmsConnected
        }
        rate {
          providerAdapter
          providerURL
          manualARR
          pmsConnected
          readRatePlanDataFromPMS
        }
        restriction {
          providerAdapter
          providerURL
          manualARR
          pmsConnected
          readRatePlanDataFromPMS
        }
        booking {
          bookingNotesEnabled
          bookingNotesSupportedAdapters
          providerAdapter
          providerURL
          pmsCommunicationMode
          bookingTimeout
          occupancyPercentThreshold
          pmsConnected
        }
      }
      notificationSettings {
        notificationType
        notificationTypeName
        notificationTypeNameTranslatedList {
          label
          nativeLabel
          value
        }
        channelDeliveries {
          active
          receivers
          type
        }
      }
      addOns {
        type
        name
        nameTranslatedList {
          label
          nativeLabel
          value
        }
        code
        applyMultiplier
        perPerson
        perRoomNight
      }
      ARIRetrievals {
        adapter
        retrievalInterval
        lastRetrievalAttempt
        nextRetrievalAttempt
      }
      associatedGateways
    }
  }
`
export const PROVIDERS_SUBMIT_GENERATE_MUTATION = gql`
  mutation ProvidersSubmitGenerate(
    $propertyCode: String!
    $input: ProvidersSubmitInput!
  ) {
    providersSubmitGenerate(propertyCode: $propertyCode, input: $input) {
      message
    }
  }
`
export const PROVIDERS_SUBMIT_MODIFY_MUTATION = gql`
  mutation ProvidersSubmitModify(
    $propertyCode: String!
    $input: ProvidersSubmitInput!
  ) {
    providersSubmitModify(propertyCode: $propertyCode, input: $input) {
      message
    }
  }
`
